import React from "react";

export default function Navbar() {
  return (
    <nav className="fixed w-full bg-white/90 dark:bg-slate-500 dark:text-white backdrop-blur-md shadow-md z-50">
      <div className="max-w-6xl mx-auto flex justify-between items-center p-4">
        <h1 className="text-2xl font-bold text-blue-600 dark:text-white">Daniel Mirigi</h1>
        <ul className="flex gap-6 text-gray-700  dark:text-white font-medium">
          <li><a href="#about">About</a></li>
          <li><a href="#skills">Skills</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>
    </nav>
  );
}
